﻿import React from 'react';
import PropTypes, { } from 'prop-types';
import { Tooltip } from "components/tooltip";
import { Button } from 'components/buttons';

import './Filter.css';

export function FilterButton({
    filters = [],
    onToggle
}) {
    
    return (
        <div className="filter-count-container">
            <Tooltip content="Filter" position="right">
                <Button icon="filter" large minimal onClick={onToggle} />                    
                {filters?.length > 0 && (
                    <span className="filter-count">
                        {filters.length}
                    </span>
                )}             
            </Tooltip>
        </div>
    );
}

FilterButton.propTypes = {
    filters: PropTypes.array,
    onToggle: PropTypes.func.isRequired
};